import { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "反差追踪到底是什么网站？",
    a: "反差追踪是一家中立的信息整理站点，专注梳理走红的「反差」类网络事件中的主角身份、当事人来源与传播链条。我们不生产情绪，只负责把线索、证据分级与时间线整理清楚，供读者自行判断。",
  },
  {
    q: "「主角」和「当事人」有什么区别？",
    a: "主角通常指被镜头与话题聚焦的那个人，是被呈现的角色；当事人则涵盖更广，包括亲历者、爆料者、被卷入的周边人物甚至传播者。本站会在正文中严格区分这两类概念，避免误伤。",
  },
  {
    q: "你们会直接公布人物真实身份吗？",
    a: "不会。本站仅呈现公开信息中的「高度疑似」线索，并明确标注其可信层级与待核验状态。在当事人本人回应或权威渠道确认之前，我们不以任何形式对个体身份作最终定论。",
  },
  {
    q: "如何判断一条线索是否可信？",
    a: "我们把证据划分为客观记录、直接发声、匿名爆料三个层级。截图与录音单独出现时不构成证据链，只有多条互相独立又彼此印证、且不存在信息互斥点的线索，才会被标为「高度疑似」。",
  },
  {
    q: "你们的内容来源是什么？",
    a: "所有素材均来自可检索的公开渠道，包括平台公开发布、公示信息、媒体报道与当事人公开回应。我们会在行文中说明线索出处，并对来源不明的二手转述特别提示风险。",
  },
  {
    q: "为什么有些档案标记为「待核验」？",
    a: "当一个事件的线索量不足、存在明显矛盾或当事人尚未回应时，我们会将其归入「待核验」，并持续跟进。标记待核验，意味着我们承认此刻信息不足，而不是默认内容为假。",
  },
  {
    q: "我可以投稿线索或申请删除吗？",
    a: "如你掌握可公开核实的补充信息，或认为本站内容对你造成了误伤，可通过邮件与我们联系。我们会在核验后修正表述，或依据正当理由调整相关内容。",
  },
];

const principles = [
  { title: "线索分级", desc: "区分客观记录、直接发声与匿名爆料，不做一刀切判断。", icon: "ri-layout-grid-line" },
  { title: "信源标注", desc: "说明每一条关键线索的来源，便于读者自行回查与复核。", icon: "ri-link-m" },
  { title: "存疑不下判", desc: "证据不足即标注待核验，不给个体任何提前定论。", icon: "ri-honour-line" },
  { title: "保持开放", desc: "欢迎不同视角的公开信息，愿意依据新证据随时修正。", icon: "ri-refresh-line" },
];

export default function About() {
  const [open, setOpen] = useState(0);

  return (
    <div className="bg-background-50">
      {/* head */}
      <section className="relative overflow-hidden bg-secondary-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-700">
            <i className="ri-flag-line" /> 关于本站
          </p>
          <h1 className="font-heading mt-3 max-w-2xl text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
            立场、原则与那些我们不会做的事
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
            反差追踪诞生的初衷很简单：在一次次「先站队、后核实」的舆论循环里，提供一个更冷静的信息整理样本。
          </p>
        </div>
      </section>

      {/* philosophy */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">我们如何看待「反差」事件</h2>
            <div className="mt-5 space-y-4 text-sm leading-relaxed text-foreground-700">
              <p>
                每一起走红的反差事件，最初都只是一个普通人与另一群普通人之间的冲突或落差。是算法的放大与情绪的传染，让它变成一场全民围观。
              </p>
              <p>
                我们无意扮演「道德裁判」，也不靠放大冲突获取流量。本站的核心工作是信息整理：谁被指向、线索从何而来、证据成色如何、时间线如何推进。把这些摆清楚，读者自然能形成自己的判断。
              </p>
              <p>
                我们更希望传达一种朴素的观念——在证据不足时承认「还不知道」，并不丢人；急着给陌生人下结论，才是真正危险的习惯。
              </p>
            </div>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/renwu"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-2.5 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700"
              >
                查看追踪档案
              </Link>
              <Link
                to="/zixun"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                阅读梳理文章
              </Link>
            </div>
          </div>

          {/* principles cards */}
          <div className="grid gap-3 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-lg`} />
                </span>
                <h3 className="font-heading mt-3 text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* what we don't do */}
      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
          <h2 className="font-heading text-2xl font-bold text-foreground-950">我们不会做这些事</h2>
          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {[
              {
                t: "不公布未核实身份",
                d: "即使一条线索传得再广，只要未被权威渠道确认，我们就不将其作为既定事实呈现，而是标注待核验。",
                i: "ri-close-circle-line",
              },
              {
                t: "不做单方面站队",
                d: "我们不替爆料方说话，也不替当事人开脱。双方公开说法会并列呈现，由读者依据证据判断。",
                i: "ri-git-merge-line",
              },
              {
                t: "不渲染二次伤害",
                d: "我们避免重复散布涉及真实个体的隐私细节，也不以「吃瓜」姿态消费当事人，坚持人就事论事。",
                i: "ri-shield-check-line",
              },
            ].map((c) => (
              <div key={c.t} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className={`${c.i} text-lg`} />
                </span>
                <h3 className="font-heading mt-3 text-base font-bold text-foreground-950">{c.t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* faq */}
      <section className="mx-auto max-w-4xl px-4 py-12 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">FAQ</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950">常见问题</h2>
        </div>
        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => (
            <div
              key={f.q}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="text-sm font-medium text-foreground-900">{f.q}</span>
                <i
                  className={`text-foreground-500 transition-transform ${
                    open === i ? "rotate-45 ri-add-line" : "ri-add-line"
                  }`}
                />
              </button>
              {open === i && (
                <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                  {f.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* contact */}
      <section className="border-t border-background-200 bg-secondary-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
          <div className="grid items-center gap-8 md:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950">联系反差追踪</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                如需补充可公开核实的线索，或认为本站内容存在误伤，欢迎通过邮件与我们取得联系。我们会在核验后及时处理。
              </p>
              <div className="mt-5 flex flex-col gap-3 text-sm text-foreground-700">
                <span className="flex items-center gap-2.5">
                  <i className="ri-mail-line text-primary-600" /> contact@fanchazhuizong.example
                </span>
                <span className="flex items-center gap-2.5">
                  <i className="ri-time-line text-primary-600" /> 工作日 10:00 - 18:00 回复
                </span>
              </div>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">免责与致谢</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                本站所有内容均为公开信息的整理与评论，不构成对任何真实个体的法律或道德定性。对文中素材的原始发布者、讨论参与者的理性表达表示感谢——正是大量愿意多方核实的普通读者，构成了这个站持续运转的底气。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}